import { Component, inject } from '@angular/core';
import { toFixed } from 'src/app/lib/roundOf';

// Import service
import { WalletService } from 'src/app/services/wallet.service';
import { CurrencyFacade } from '../../../store/currency';
import { FormBuilder, FormGroup } from '@angular/forms';
import { getDisplayedPages } from 'src/app/lib/pagination';
import { ExportService } from 'src/app/services/export-service.service';
@Component({
  selector: 'app-transactionhistory',
  templateUrl: './transactionhistory.component.html',
  styleUrls: ['./transactionhistory.component.css']
})
export class TransactionhistoryComponent {
  private readonly currencyFacade: CurrencyFacade = inject(CurrencyFacade);
  form: FormGroup;
  currencyList: any = []
  toFixed = toFixed
  txnHistory: any = []
  filter: any = {
    page: 1,
    limit: 10,
    totalPages: 0,
    coin: "all",
    paymentType: "all",
    payment: "all",
    status: "all"
  }
  // paginator: number[] = []
  getDisplayedPages: number[] = []


    searchForm: FormGroup;
  
    displayedColumns = {
      label: [
        'Currency',
        'Date',
        'Payment Type',
        'Amount',
        'Txn Ref',
        'Status'
      ],
      cols: [
        'coin',
        'createdAt',
        'paymentType',
        'actualAmount',
        'txid',
        'status'
      ]
    };
    
  constructor(private service: WalletService, private _fb: FormBuilder,
    private exportService: ExportService
  ) {
    this.form = this._fb.group({
      coin: "all",
      paymentType: "all",
      payment: "all",

    });
    this.searchForm = this._fb.group({
      fromDate: [''],
      toDate: ['']
    });
  }

  ngOnInit() {
    this.fetchTxnHistory(this.filter);
    this.getCurrency();
    
  }

  viewAllData(){
    this.filter.limit=100000000;
        this.fetchTxnHistory(this.filter);
    
      }
  getCurrency() {
    this.currencyFacade.currency$
      .subscribe({
        next: (data: any) => {
          this.currencyList = data && data.filter((el: any) => el.status == 'active')

        },
        error: (err: any) => {
          if ([400, 404].includes(err.status)) {
            const validationErrors = err.error.errors;
          } else if (err.status === 500) {
          }
        },
        complete: () => { }
      })
  }


  downloadExcel() {
    // this.filter.limit=100000000;
    // this.fetchTxnHistory(this.filter)
    const req = {
      ...this.displayedColumns,
     ... {data: this.txnHistory?.data},
     ... {filename: 'Transaction History'},
      ...{BotServicedateField: ['create_time']}
    };
    this.exportService.exportExcel(req);
  }

  fetchTxnHistory(filter: any) {
    this.service.gettxnhistory(filter).subscribe({
      next: (data: any) => {
        this.txnHistory = data.result
        // this.filter.page = data.count
        this.filter.totalPages = Math.ceil(data.result.count / this.filter.limit)
        // this.paginator = Array(this.filter.totalPages).fill(1).map((x, y) => x + y)
        this.getDisplayedPages = getDisplayedPages(this.filter.page, this.filter.totalPages, 5)
      },
      error: () => { }
    })
  }

  nextPage() {
    this.filter.page += 1

    this.fetchTxnHistory(this.filter);
  }

  goToPage(pageNo: number) {
    this.filter.page = pageNo
    this.fetchTxnHistory(this.filter);
  }

  previousPage() {
    if (this.filter.page > 1)
      this.filter.page -= 1

    this.fetchTxnHistory(this.filter);
  }

  onOptionChange(event: any) {
    const name = event.target.id
    const filterValue = event.target.value
    this.filter[name] = filterValue

  }

  searchfilter() {
    this.filter.page = 1;
    this.filter.limit = 100000;
    this.fetchTxnHistory(this.filter); // It updates this.txnHistory internally
  
    const { fromDate, toDate } = this.searchForm.value;
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
  
    // Wait a bit before filtering to ensure data is fetched
    setTimeout(() => {
      if (this.txnHistory?.data && Array.isArray(this.txnHistory.data)) {
        this.txnHistory.data = this.txnHistory.data.filter((item: { createdAt: string }) => {
          const createdAt = new Date(item.createdAt);
          if (from && to) return createdAt >= from && createdAt <= to;
          else if (from) return createdAt >= from;
          else if (to) return createdAt <= to;
          return true;
        });
      }
    }, 300); // Adjust delay as needed
  }
  
  
  


  resetFilter(): void {
    this.searchForm.reset();
    this.fetchTxnHistory(this.filter);
    this.txnHistory = [...this.txnHistory];
  }

 

  clearfilter() {
    const initialfilter = {
      page: 1,
      limit: 10,
      totalPages: 0,
      coin: "all",
      paymentType: "all",
      payment: "all",
    }
    // this.filter.page = 1
    this.form.reset()
    this.form.patchValue({
      coin: "all",
      paymentType: "all",
      payment: "all",

    })
    this.fetchTxnHistory(initialfilter);
    this.filter = initialfilter
  }



}



